import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import PanelOverlay from "./PanelOverlay";
import AvatarWithBell from "core/SiteHeader/components/AvatarWithBell";

// helpers
import { disableBellNotifications } from "core/SiteHeader/helpers.js";

//styles
const AvatarStyled = styled.div`
    display: flex;
    justify-content: flex-end;
`;

// context
import {
    PanelOverlayProvider,
    OpenButton
} from "core/SiteHeader/Mobile/components/PanelOverlay/index.js";

// component
const AuthMenu = () => {
    const { setHideBell, hasMounted } = useSiteHeader();

    const onClose = () => {
        setHideBell(true);
    };

    return (
        <PanelOverlayProvider
            position="right"
            id="auth-menu"
            label="Open Auth Menu"
            onOpen={disableBellNotifications}
            onClose={onClose}
        >
            <div>
                <OpenButton>
                    <AvatarStyled>
                        <AvatarWithBell />
                    </AvatarStyled>
                </OpenButton>
                {hasMounted && <PanelOverlay />}
            </div>
        </PanelOverlayProvider>
    );
};

export default AuthMenu;
